import React, { useState } from 'react';
import {
  INSURANCE_INSIGHTS_THUMBS,
  INSURANCE_SWIMLANE_PREVENTATIVE_PERKS_TAPPED,
} from '../../../../../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import {
  getInsuranceFeedback,
  setInsuranceFeedbackGiven,
} from '../../../../../../Account/Profile/Insurance/util/insuranceInsights';

import withTileAction from '../../../util/withTileAction';
import View from './View';
import { safeGet } from '../../../../../../../core/util/object';

type Props = {
  tile: any;
  tileIndex: number;
  userProfile: any;
  doTileAction?: (...args: any[]) => any;
};

const InsuranceInsight = (props: Props) => {
  const { doTileAction, tile, tileIndex, userProfile } = props;
  const userProfileId = safeGet(userProfile)('user_profile_id');

  const [feedbackGiven, setFeedbackGiven] = useState(
    () => getInsuranceFeedback(tile.id, userProfileId) !== null
  );
  const [feedbackJustGiven, setFeedbackJustGiven] = useState(false);

  if (!userProfileId) return null;

  const handleThumb = (action: any) => {
    setFeedbackGiven(true);
    setFeedbackJustGiven(true);
    analyticsTrackEvent(INSURANCE_INSIGHTS_THUMBS, { action, tileId: tile.id });
    setInsuranceFeedbackGiven(tile.id, userProfileId, action);
  };

  const handleClickContent = () =>
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    doTileAction(tileIndex, tile, userProfile, null, INSURANCE_SWIMLANE_PREVENTATIVE_PERKS_TAPPED);

  return (
    <View
      feedbackGiven={feedbackGiven}
      feedbackJustGiven={feedbackJustGiven}
      header={tile.header}
      linkText={tile.linkText}
      onClickContent={handleClickContent}
      onClickThumb={handleThumb}
      title={tile.title(props)}
    />
  );
};

export default withTileAction(InsuranceInsight);
